import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {Alert} from '../functions'

// eslint-disable-next-line no-undef
const object = vnObject

window.Parsley.addValidator('frNumber', {
    requirementType: 'string',
    validateString: function (value) {
        return isValidPhoneNumber(value, 'FR')
    },
})

const form = $('.contact-form')

if (form.length) {
    form.parsley().on('form:success', function () {
        form.attr('data-success', 'true')
    })

    form.parsley().on('form:error', function () {
        form.attr('data-success', 'false')
    })

    $('.contact-form').on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const $form = $(this)

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: $form.serialize() + '&action=' + 'vn_contact',
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            success: (res) => {
                $form.removeClass('sending')

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }

                Alert(res.success, res.data.message)

                res.success && $form[0].reset()
            },
        })
    })
}
